<template>
  <div>
    <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template #activator="{ on }">
        <div v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-date-picker v-model="date" :min="min" :max="max" @input="onInput"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      date: this.value,
      menu2: false
    }
  },
  watch: {
    value(value) {
      this.date = value
    }
  },
  methods: {
    onInput(date) {
      this.menu2 = false

      this.$emit('input', date)
      this.$emit('change', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/DatePickerWithoutButton.vue